<div class="textarea-main-container height-100 flexbox-column">
    <div class="textarea-container flexbox-column height-100" :class="get__border">
        <div class="label montserrat" :class="get__color">{{label}}</div>
        <textarea :id="id" @focus="toggleFocus()" @blur="toggleFocus()" :class="disabled? 'disabled' : ''"
            v-model="textValue" :maxlength="maxLength" class="height-100"></textarea>
    </div>
    <div v-if="showWordCount" class="char-remaining montserrat font-13">{{maxLength -
        charactersRemaining}}/{{maxLength}}</div>
</div>